import { useState, useEffect, useCallback, useRef } from 'react';

// React hook for delaying calls with time
// returns callback to use for cancelling

const useTimeout = (callback: () => void, timeout = 0, start=false): (() => void) => {
  const timeoutIdRef = useRef<NodeJS.Timeout>();
  // const [start, setStart] = useState(false)

  const cancel = useCallback(() => {
    const timeoutId = timeoutIdRef.current;

    if (timeoutId) {
      timeoutIdRef.current = undefined;
      clearTimeout(timeoutId);
    }
  }, [timeoutIdRef]);

  useEffect(() => {
    if(start)
      timeoutIdRef.current = setTimeout(callback, timeout);
      
    return cancel;
  }, [callback, timeout, cancel, start]);

  return cancel;
};

export default useTimeout;
